export const storage = {
  // ==== ACCESS TOKEN ====
  setToken: (token: string): void => {
    localStorage.setItem('access_token', token);
  },

  getToken: (): string | null => {
    return localStorage.getItem('access_token');
  },

  removeToken: (): void => {
    localStorage.removeItem('access_token');
  },

  // ==== REFRESH TOKEN ====
  setRefreshToken: (token: string): void => {
    localStorage.setItem('refresh_token', token);
  },

  getRefreshToken: (): string | null => {
    return localStorage.getItem('refresh_token');
  },

  removeRefreshToken: (): void => {
    localStorage.removeItem('refresh_token');
  },

  // ==== USER ====
  setUser: (user: any): void => {
    localStorage.setItem('user', JSON.stringify(user));
  },

  getUser: (): any => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  removeUser: (): void => {
    localStorage.removeItem('user');
  },

  // ==== CLEAR ALL ====
  clear: (): void => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
  },

  // ==== REGISTRATION DATA (sessionStorage) ====
  setRegistrationData: (data: any): void => {
    sessionStorage.setItem('registration_data', JSON.stringify(data));
  },

  getRegistrationData: (): any => {
    const data = sessionStorage.getItem('registration_data');
    return data ? JSON.parse(data) : null;
  },

  clearRegistrationData: (): void => {
    sessionStorage.removeItem('registration_data');
    localStorage.removeItem('hasSeenWelcome');
  },

  setPendingInviteCode: (code: string): void => {
    sessionStorage.setItem('pendingInviteCode', code);
  },

  getPendingInviteCode: (): string | null => {
    return sessionStorage.getItem('pendingInviteCode');
  },

  removePendingInviteCode: (): void => {
    sessionStorage.removeItem('pendingInviteCode');
  },
};
